import { PerksPageTemplate } from "./template";
import { usePerksPage } from "./logic";

export const PerksPage = () : JSX.Element => {
    const props = usePerksPage();

    return (
        <PerksPageTemplate {...props}/>
    )
}